import React from 'react'
import { useRouteMatch, Switch, Route } from 'react-router-dom'
import NewsSummaries from './news-summaries'
import NewsItem from './news-item'

const News = ({ data, ...props }) => {
  const match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.path}/:newsItemSlug`}>
        <NewsItem data={data} {...props} />
      </Route>
      <Route path={match.path}>
        <NewsSummaries data={data} {...props} />
      </Route>
    </Switch>
  )
}

export default News